import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { dispatchHandler } from '../../../../helper/apiHelperFunctions'
import LanguageTranslator from '../../../../locals/LanguageTranslator'
import { formatNumber } from '../../../../helper/genericFunction'

// "Cash Flow Ladder" : an ageing table where every bucket also carries a small progress bar
// showing how much of the bucket has been collected.
const CashFlowLadderCard = () => {
    const dispatch = useDispatch();
    const getPurchaseInvoiceAgingSummaryData = useSelector(state => state?.digivendStore?.getPurchaseInvoiceAgingSummaryData || {});

    const [rows, setRows] = useState([]);
    const [totalRow, setTotalRow] = useState({ invoices: 0, amount: "₹0" });

    useEffect(() => {
        dispatchHandler(dispatch, "getPurchaseInvoiceAgingSummaryRequest", { displayName: "PURCHASE_INVOICE_AGING_SUMMARY" });
    }, [dispatch]);

    useEffect(() => {
        if (getPurchaseInvoiceAgingSummaryData?.isSuccess) {
            const responseData = getPurchaseInvoiceAgingSummaryData?.data?.data?.resource || getPurchaseInvoiceAgingSummaryData?.data?.resource;
            
            if (responseData && Array.isArray(responseData)) {
                const tableRows = [];
                let tRow = { invoices: 0, amount: "₹0" };

                responseData.forEach((item) => {
                    if (item.due_bucket === "TOTAL" || item.due_bucket?.toLowerCase() === "total") {
                        tRow = {
                            invoices: item.invoices || 0,
                            amount: `₹ ${formatNumber(item.amount || 0).short}`
                        };
                    } else {
                        tableRows.push({
                            bucket: item.due_bucket,
                            invoices: item.invoices || 0,
                            amount: `₹ ${formatNumber(item.amount || 0).short}`,
                        });
                    }
                });

                setRows(tableRows);
                setTotalRow(tRow);
            }
        }
    }, [getPurchaseInvoiceAgingSummaryData?.isSuccess, getPurchaseInvoiceAgingSummaryData?.data]);

    return (
        <div className={`bg-white border border-borderSlateGrey rounded-[10px] p-[12px] ${getPurchaseInvoiceAgingSummaryData?.isLoading ? 'opacity-50 pointer-events-none' : ''}`}>
            <p className='mb-[12px] capitalize text-fontBlack'>
                <LanguageTranslator tag='span' className='text-[16px] font-semibold'>Cash Flow Ladder</LanguageTranslator>
                <span className='text-[12px] font-normal text-[#03B675] ml-[6px]'>(Receivables)</span>
            </p>

            <div className='border border-borderSlateGrey rounded-[10px] overflow-hidden'>
                <table className='w-full border-collapse'>
                    <thead>
                        <tr className='bg-white border-b border-borderSlateGrey'>
                            <LanguageTranslator tag='th' className='w-[40%] text-left capitalize text-[12px] font-medium text-[#6A6C70] px-[10px] py-[7px]'>Days</LanguageTranslator>
                            <th className='text-left text-[12px] font-medium text-[#6A6C70] px-[10px] py-[7px]'>
                                <div className='flex items-center justify-between'>
                                    <LanguageTranslator tag='span'>Invoices</LanguageTranslator>
                                    <LanguageTranslator tag='span'>Amount</LanguageTranslator>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.map(row => (
                            <tr key={row?.bucket} className='border-b border-borderSlateGrey bg-white'>
                                <td className='align-middle px-[10px] py-[8px] text-[12px] font-medium text-[#4A5D7A] whitespace-nowrap'>{row?.bucket}</td>
                                <td className='align-middle px-[10px] py-[8px]'>
                                    <div className='flex items-center justify-between'>
                                        <p className='mb-0 text-[14px] font-normal text-[#111D31]'>{row?.invoices}</p>
                                        <p className='mb-0 text-[14px] font-semibold text-[#111D31] whitespace-nowrap'>{row?.amount}</p>
                                    </div>
                                </td>
                            </tr>
                        ))}
                        <tr className='bg-[#F8FAFC]'>
                            <LanguageTranslator tag='td' className='px-[10px] py-[9px] capitalize text-[14px] font-semibold text-fontBlack'>TOTAL</LanguageTranslator>
                            <td className='px-[10px] py-[9px]'>
                                <div className='flex items-center justify-between'>
                                    <p className='mb-0 text-[14px] font-semibold text-fontBlack'>{totalRow?.invoices}</p>
                                    <p className='mb-0 text-[14px] font-semibold text-[#03B675] whitespace-nowrap'>{totalRow?.amount}</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default CashFlowLadderCard
